<div class="p-grid p-justify-between p-align-center topbar" id="top">
  <figure>
    <img src="assets/ihgtheme/imgs/IHG_white_Logo.png" />
  </figure>
  <div class="ui-widget p-col"></div>
  <h1 class="ui-widget p-col">{{ getRouteTitle() }}</h1>
  <div class="ui-widget p-col-fixed"></div>
  <div style="width: 115px">&nbsp;</div>
</div>
<div class="topbar-spacer"></div>
<p-toast position="top-center"></p-toast>
<p-toast key="bottom-right" position="bottom-right"></p-toast>
<p-toast key="network" position="bottom-right"></p-toast>
<div class="mainwindow">
  <router-outlet></router-outlet>
</div>
